import {
  usePreloadedBalanceData,
  usePrivateBalanceRows,
  useUnifiedPrivateRows,
} from "../common/components/Balance";
import { useRedactedV2 } from "../redacted/v2";
import { usePreloadedAccountData } from "../services/accountData";
import { useRedacted } from "../services/redacted";
import { portfolioBalancesValue } from "./utils";

/** Use the same Reserve + Spending rows as the private portfolio table.
 * GraphQL balances deliberately omit the pooled proxy; never add its balance
 * back, nor add Reserve to rows that already include it. */
export const usePortfolioBalanceValue = () => {
  const { isPrivateMode } = useRedacted();
  const { isLoading: accountLoading } = usePreloadedAccountData(false);
  const balances = usePreloadedBalanceData();
  const v2 = useRedactedV2();
  const legacyRows = usePrivateBalanceRows();
  const unifiedRows = useUnifiedPrivateRows();
  // Model B counts returning sub balances once, beside the Reserve.
  const privateRows = v2.modelB.enabled ? unifiedRows : legacyRows;
  const isLoading = accountLoading || !balances;
  return {
    isLoading,
    value: portfolioBalancesValue({
      isPrivateMode,
      balances,
      privateRows,
      isLoading,
    }),
  };
};
